import NavButtons from 'components/Software/iOS/NavButtons';
import ForumBox from 'components/Software/iOS/IP_Cam_Viewer/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};